
import { io, Socket } from 'socket.io-client';
// Proxied dev stacks (orc + Traefik) set VITE_REALTIME_URL=/; see orc/README.md.
const REALTIME_URL = import.meta.env.PROD ? "wss://realtime-tuna.fancyhands.com" :
    import.meta.env.VITE_REALTIME_URL ? new URL(import.meta.env.VITE_REALTIME_URL, window.location.origin).origin :
    "ws://localhost:3001";
import { RealtimePacketType } from 'contexts/realtime_context';

interface ServerToClientEvents {
    identified: (connectionId : string) => void;
	published: (data : RealtimePacketType) => void;
    // basicEmit: (a: number, b: string, c: Buffer) => void;
    // withAck: (d: string, callback: (e: number) => void) => void;
}


// type ReceiverFunc = (data: object) => void;

interface ClientToServerEvents {
    identify: (id: string) => void;
	send: (data: object) => void;
    join: (channel: string) => void;
	// basicEmit: (a: number, b: string, c: Buffer) => void;
	// withAck: (d: string, callback: (e: number) => void) => void;
}


const socket : Socket<ServerToClientEvents, ClientToServerEvents> = io(REALTIME_URL, {
        autoConnect: false,
        transports : ['websocket'],
        query: {
            morty_token: null
        }
    });

export default socket;
